import { random } from "lodash-es";
import * as echarts from 'echarts';


export default function (chartData = []) {


  const x = chartData.map(item => item.record_time)
  const p = chartData.map(item => item.pcspower_dc)

  /**
   * @type {import('echarts').EChartsOption}
   */
  const option = {
    grid: {
      top: 2,
      bottom: 2,
      left: 2,
      right: 2,
    },
    xAxis: {
      show: false,
      type: 'category',
      data: x,//['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
    },
    yAxis: {
      type: 'value',
      show: false,
    },
    series: [
      {
        data: p,//Array.from({ length: 10 }, (_, i) => random(0, 100)),
        type: 'line',
        color: '#3075E8',
        silent: true,
        // smooth: 0.3,
        symbol: 'none',
        lineStyle: {
          width: 2,
        },
        areaStyle: {
          color: echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: 'rgba(48, 117, 232, 1)'
          }, {
            offset: 1,
            color: 'rgba(48, 117, 232, 0)'
          }]),
        }
      }
    ]
  };

  return option;
}
